import "./graphic-picker.style.scss";
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import UploadIcon from "../../Assets/applifecycle/walkthru-upload.svg";

import RemoveImageCross from "../../Assets/applifecycle/remove-image-cross.svg";

import DevStorageAPI from "../../api/DevStorage";
import { CustomToast } from "../custom-toast/CustomToast";
import { sanitiseUploadFileName } from "../helpers/funcHelper";

function FileDropzone({ onFileSelect, fileTypeCheck, dimensionCheck }) {
  const onDrop = useCallback((acceptedFiles) => {
    onFileSelect(acceptedFiles[0]);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: fileTypeCheck,
    onDrop,
  });

  return (
    <div
      style={{ width: "100%", height: "100%", overflow: "hidden" }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <div className="banner-dropzone">
        <img className="banner-dropzone-icon" alt="upload" src={UploadIcon} />
        {isDragActive ? (
          <p className="banner-dropzone-text">Drop to upload</p>
        ) : (
          <React.Fragment>
            <p className="banner-dropzone-text">
              Drag and drop an image (PNG or JPG) file here or click
            </p>
            {dimensionCheck && (
              <p className="banner-dropzone-size">
                Required size: {dimensionCheck.width}px x {dimensionCheck.height}px
              </p>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default class BannerPicker extends React.Component {
  /// selectedFileData = undefined;

  constructor(props) {
    super(props);

    this.state = {
      status: 0,
      name: "",
      progress: 0,
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      path: "",
      localPreviewUrl: "",
      size:0,

    };
  }

  generateSAS() {
    var api = new DevStorageAPI();
    api
      .generateSASForAnyDoc({
        type: "organization",
        fileName: this.state.name,
      })
      .then((response) => {
        this.setState({
          sasFileName: response.data.data.fileName,
          sasToken: response.data.data.token,
          sasUrl: response.data.data.url,
          path: response.data.data.path,
          sasUrlWithoutToken: response.data.data.url.replace(
            "?" + response.data.data.token,
            ""
          ),
        });

        this.uploadFile();
      })
      .catch((error) => {
        this.showError("Unable to upload please try uploading again");
        CustomToast(error.response.data.message);
      });
  }
  uploadFile() {
    var api = new DevStorageAPI();

    api
      .uploadFile(this.state.sasUrl, this.selectedFileData, (progress) => {
        this.setState({ progress: progress });
      })
      .then((response) => {
        const localPreviewUrl = this.selectedFileData
          ? URL.createObjectURL(this.selectedFileData)
          : "";
        this.setState({ status: 2, localPreviewUrl });

        this.props.onComplete({
          fileName: this.state.sasFileName,
          url: this.state.sasUrlWithoutToken,
          path: this.state.path,
          size:this.state.size
        });
      })
      .catch((error) => {
        this.props.onComplete({ fileName: "", url: "", path: "", size:0 });

        this.showError("Unable to upload please try uploading again");
      });
  }

  resetFile() {
    if (this.state.localPreviewUrl) {
      URL.revokeObjectURL(this.state.localPreviewUrl);
    }
    this.setState({
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      path: "",
      localPreviewUrl: "",
      size:0,

    });
    this.props.onComplete({ fileName: "", url: "" , path: "", size:0});
  }

  handleFileSelect(file) {
   

    if (file === undefined) {
      this.showError("Select Valid File");
      return;
    }
    var fileExtension = "";
      
      if(file.name.lastIndexOf(".") > 0){

        fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase();
      }
      
        if(fileExtension !== "jpg" && fileExtension !== "jpeg" && fileExtension !== "png"){
          CustomToast("Only JPG & PNG are supported");
          this.showError("Only JPG & PNG are supported");
          return;
        }
      var img = new Image();
      img.onload = () => {
        const width  = img.naturalWidth,
              height = img.naturalHeight
              if(width!==this.props.dimensionCheck.width || height!==this.props.dimensionCheck.height){
                // console.log(width,height);
                CustomToast(`Dimension should be ${this.props.dimensionCheck.width}px x ${this.props.dimensionCheck.height}px`);
                this.showError(`Dimension should be ${this.props.dimensionCheck.width}px x ${this.props.dimensionCheck.height}px`);
                return;
              }
              this.resetFile();
              this.selectedFileData = file;
              this.setState({ size:file.size,name:sanitiseUploadFileName(file.name) });
              this.generateSAS();
      }
      img.src = window.URL.createObjectURL(file);
     
  }

  showError(msg) {
    this.resetFile();
    this.setState({ errorMsg: msg });
  }

  render() {
    const comp = () => {
      switch (this.state.status) {
        case 0:
          return (
            <FileDropzone
              onFileSelect={(file) => {
                this.handleFileSelect(file);
              }}
              fileTypeCheck={this.props.fileTypeCheck}
              dimensionCheck={this.props.dimensionCheck}
            />
          );
        case 1:
          return (
            <div className="file-uploading-container-gpicker">
              Uploading {this.state.progress}%
            </div>
          );
        case 2:
          return (
            <div className="preview-container">
             
                <img
                  alt="img"
                  className="preview-img"
                  src={this.state.localPreviewUrl || this.state.sasUrlWithoutToken}
                />
              
              <img
                alt="img"
                className="remove-img"
                onClick={() => this.resetFile()}
                src={RemoveImageCross}
              />
            </div>
          );
        default:
          return <div></div>;
      }
    };

    return (
      <React.Fragment>
        <div
          style={{ width: this.props.width, height: this.props.height, borderRadius:"0px" }}
          className="graphic-select-container-gpicker"
        >
          {comp()}
        </div>

        <span style={{ color: "red" }} className="file-upload-error">
          {this.state.errorMsg}
        </span>
      </React.Fragment>
    );
  }
}
